import { render, staticRenderFns } from "./BusinessTypes.vue?vue&type=template&id=1f8dd43d&scoped=true&"
import script from "./BusinessTypes.vue?vue&type=script&lang=js&"
export * from "./BusinessTypes.vue?vue&type=script&lang=js&"
import style0 from "./BusinessTypes.vue?vue&type=style&index=0&id=1f8dd43d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8dd43d",
  null
  
)

export default component.exports